import React from 'react'
import Header from '../../components/layout/Header'
import Sidebar from '../../components/layout/Sidebar/Sidebar'
import ClientRow from './ClientRow'
import Button from '../../components/ui/buttons/Button'

// const clients = [
//   {
//     id: 1,
//     name: 'José da Silva Figueiredo',
//     email: 'josedasilva@gmail.com',
//     phone: '(84) 9 9999-9999',
//     created_at: '02/01/2025',
//     steps: ['preencher_consulta']
//   },
//   // ...
// ]

const Dashboard = ({ clients }) => {
  return (
    <div className="flex flex-col h-screen font-sans">
      <Header />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar />

        <div className="flex-1 p-10 overflow-auto">
          {/* Header */}
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-semibold text-gray-700">Cadastro de clientes</h2>
            <Button>➕ CADASTRAR NOVO CLIENTE</Button>
          </div>

          {/* Search and sort */}
          <div className="flex items-center justify-between mb-6">
            <p className="text-gray-600 font-medium">Clientes em processo de cadastro</p>
            <input
              type="text"
              placeholder="Pesquisar cliente..."
              className="border border-gray-300 rounded px-4 py-2 text-sm w-64"
            />
          </div>

          {/* Table headers */}
          <table className="w-full text-left">
            <thead>
              <tr className="text-gray-500 text-sm border-b border-gray-300">
                <th className="py-2">Nome</th>
                <th className="py-2">E-mail</th>
                <th className="py-2">Telefone</th>
                <th className="py-2">Cadastrado em</th>
                <th className="py-2">Ações</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((client) => (
                <ClientRow key={client.id} client={client} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

Dashboard.defaultProps = {
    clients: []
  }

export default Dashboard
